import router from '@/router';
import store from '@/store';

const applySiteParamToRoute = (route, entity) => {
  if (entity.siteId) {
    const site = store.getters.getSiteFromSiteId(entity.siteId);
    route.params.site = site.idAlias;
  }
  return route;
};
export const entityEditorRoute = {
  default(entityType, entity) {
    const route = {
      name: `${entityType}.editor`,
      params: {
        id: entity.id,
      },
    };
    if (entity.type) {
      route.params.type = entity.type;
    }
    return applySiteParamToRoute(route, entity);
  },
  adMap(entityType, entity) {
    return applySiteParamToRoute({
      name: 'entity.editor',
      params: {
        entity: entity.type,
        id: entity.id,
      },
    }, entity);
  },
  board(entityType, entity) {
    return applySiteParamToRoute({
      name: 'board.editor',
      params: {
        entity: entityType,
        id: entity.id,
      },
    }, entity);
  },
  landingPage(entityType, entity) {
    return applySiteParamToRoute({
      name: 'board.editor',
      params: {
        entity: entityType,
        id: entity.id,
      },
    }, entity);
  },
  entity(entityType, entity) {
    return applySiteParamToRoute({
      name: 'entity.editor',
      params: {
        entity: entityType,
        id: entity.id,
      },
    }, entity);
  },
  content(entityType, entity) {
    return applySiteParamToRoute({
      name: 'content.editor',
      params: {
        type: entityType,
        id: entity.id,
      },
    }, entity);
  },
  composition(entityType, entity) {
    return applySiteParamToRoute({
      name: 'composition.editor',
      params: {
        compositionId: entity.id,
      },
    }, entity);
  },
  get(entityType, entity) {
    // If there is a function for the entity type, call it.
    if (entityType in this) {
      return this[entityType](entityType, entity);
    }

    // If the type is a content, return a route to the content editor.
    if (store.getters.availableContentTypes.includes(entityType)) {
      return this.content(entityType, entity);
    }

    // If the type is a cms entity, return a route to the entity editor.
    if (store.getters.availableEntityTypes.includes(entityType)) {
      return this.entity(entityType, entity);
    }

    return this.default(entityType, entity);
  },
};

export const entityRouter = {
  toEditor: (entityType, entity) => router.push(entityEditorRoute.get(entityType, entity)),
};

export default {
  entityRouter,
  entityEditorRoute,
};
